

import React, { useRef } from 'react'

import { Flex } from '@stackhouse/styled-elements'

import Modal from '@stackhouse/dashboard-components/Modal'
import Button from '@stackhouse/dashboard-components/Button'

import { withDashboardContext } from '@stackhouse/dashboard-components/Dashboard'

import Form from '../../components/ResponsiveForm'


const newFilterFields = {
    name: {
        group: 0,
        id: 'name',
        type: 'text',
        required: true,
        autofocus: true,
        label: 'Filter name'
    },
    default: {
        group: 1,
        id: 'default',
        type: 'checkboxbool',
        label: 'Use as default'
    }
}


const CreateFilterModal = withDashboardContext(({ close, onSave }) => {

    const formRef = useRef(null)

    const save = () => {
        if (formRef.current && formRef.current.isValid() && onSave) {
            return onSave(formRef.current.getValue(), close)
        }
    }

    return (
        <Flex column justifyCenter p={'1em'} backgroundColor={'white'} borderRadius={10}>
            <Flex column>
                <Form ref={formRef} fields={newFilterFields} />
            </Flex>
            <Flex row alignCenter justifyEvenly p={10}>
                <Button flex={1} outline title={'Cancel'} onClick={close} />
                <Button flex={1} ml={'1em'} title={'Save filter'} onClick={save} />
            </Flex>
        </Flex>
    )
}, ({ client, withLoader }) => ({ client, withLoader }))


export default ({ onSave }) => {

    return Modal.show(
        ({ close }) => (
            <CreateFilterModal close={close} onSave={onSave} />
        ),
        { target: 'content', animation: 'zoom' }
    )
}